"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPERATORS = void 0;
exports.OPERATORS = {
    equalsIgnoreCase: 'equalsIgnoreCase',
    isEmpty: 'isEmpty',
    isNotEmpty: 'isNotEmpty',
    textContains: 'textContains',
    textDoesNotContain: 'textDoesNotContain',
    textStartsWith: 'textStartsWith',
    textEndsWith: 'textEndsWith',
    isBetween: 'isBetween',
    isNotBetween: 'isNotBetween',
    contains: 'contains',
    containsDomain: 'containsDomain',
    doesNotContainDomain: 'doesNotContainDomain',
    notContains: 'notContains',
    compareIgnoreCase: 'compareIgnoreCase',
};
//# sourceMappingURL=ConditionalLogic.js.map